import React from "react";
import PropTypes from "prop-types";
import FieldBuilder from "./fields-builder";

const StepList = ({ appData, components, screen, field }) => (
  <div
    className='step-list'
    role='list'
    aria-label={field?.accessibility?.label}
  >
    {field.fieldLayouts.map((step, index) => (
      <div
        className='step-item'
        // eslint-disable-next-line react/no-array-index-key
        key={`step-${field.name}-${index}`}
        aria-label={step?.accessibility?.label}
        role='listitem'
      >
        <div className='step-bar' aria-hidden='true'>
          {++index}
        </div>
        <div className='step-content'>
          {step.containerFields.map(stepField => (
            <FieldBuilder
              key={`field_${stepField.name}`}
              field={stepField}
              appData={appData}
              components={components}
              screen={screen}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

StepList.propTypes = {
  field: PropTypes.objectOf(PropTypes.object).isRequired,
  appData: PropTypes.objectOf(PropTypes.any),
  components: PropTypes.objectOf(PropTypes.func),
  screen: PropTypes.objectOf(PropTypes.any)
};

export default StepList;
